import {
  parseArraySOC,
  parseBooleanEnabledSOC,
  parseNumberSOC,
} from "src/features/gifts/imports/abTest";

export const getIsARGiftsEnabled = parseBooleanEnabledSOC(
  "web.ar.gifts.enabled",
  "0"
);

export const getIsSendGiftBIv2Enabled = parseBooleanEnabledSOC(
  "web.send.gift.bi.v2.enabled",
  "0"
);

export const getIsSendGiftOptimisticEnabled = parseBooleanEnabledSOC(
  "web.send.gift.optimistic.enabled",
  "0"
);

export const getIsGiftPreloadEnabled = parseBooleanEnabledSOC(
  "web.gift.preload.enabled",
  "0"
);

export const getGiftIdsToPreload = parseArraySOC("web.gift.ids.to.preload", "");

export const getMinimumAnimationPrice = parseNumberSOC(
  "web.gift.minimum.animation.price",
  "100"
);
